import dayjs from 'dayjs';
import * as type from '../actions/types';

const initialState = {
  restaurant: {},
  restaurantFetching: true,
  restaurantError: false,
  restaurantErrorMessage: '',
  todayByTimezone: -1,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_RESTAURANT_PENDING:
      return {
        ...state,
        restaurant: {},
        restaurantFetching: true,
        restaurantError: false,
        restaurantErrorMessage: '',
      };
    case type.FETCH_RESTAURANT_SUCCESS: {
      // Parse the hours here, to avoid doing it multiple times in other places
      let hoursParsed = {};
      try {
        hoursParsed = JSON.parse(action.payload?.restaurant?.hours);
      } catch {
        //
      }

      const today = dayjs().startOf('day');
      const obeeIsLive = today >= dayjs(action.payload?.restaurant?.obeeGoLiveDate);

      const currentClosures = (action.payload?.restaurant?.closures || []).filter((closure) =>
        today.isBetween(dayjs(closure.startDate), dayjs(closure.endDate), 'day', '[]'),
      );

      // The restaurant is _currently_ closed, but will be back online tomorrow
      const closedEarlyToday =
        (action.payload?.restaurant?.closeDate &&
          dayjs(action.payload?.restaurant?.closeDate).isSame(today, 'day')) ||
        currentClosures.some(
          (closure) => dayjs(closure.endDate).startOf('day').diff(today, 'day') <= 1,
        );

      // Restaurant is paused for any reason
      const paused = closedEarlyToday || currentClosures.length > 0;

      // Restaurant is paused due to churn (paused but not closed early)
      const closurePause = paused && !closedEarlyToday;

      // New restaurants are less than 2 months since creation date
      // NOTE - restaurants who churn within 2 months will incorrectly be considered new venues
      const isNew =
        action.payload?.restaurant?.created &&
        dayjs().diff(action.payload?.restaurant?.created, 'month') < 2;

      return {
        ...state,
        restaurant: {
          ...action.payload.restaurant,
          hoursParsed,
          obeeIsLive,
          closedEarlyToday,
          paused,
          closurePause,
          isNew,
        },
        todayByTimezone: action.payload.todayByTimezone,
        restaurantFetching: false,
        restaurantError: false,
        restaurantErrorMessage: '',
      };
    }

    case type.FETCH_RESTAURANT_FAILURE:
      return {
        ...state,
        restaurantError: true,
        restaurantErrorMessage: action.payload,
        restaurantFetching: false,
      };

    case type.SET_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.payload,
      };

    default:
      return state;
  }
};
